<div data-cy="iq-audio-notes-summary__page">
    <div class="flex align-center gap-15 px-30">
        <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
        <span class="sans-regular fc-black ts-15">{{ 'iq.analysis_ready' | transloco }}</span>
    </div>
    <div class="gd-vertical gap-20 pl-71 ts-15 pt-30 pr-30">
        <span>
            {{ 'iq.meeting_notes_instruction_4' | transloco }} <br>
            {{ 'iq.meeting_notes_instruction_5' | transloco }}
        </span>
    </div>

    <div class="bg-bugandy px-30 py-16 mt-40">
        <div class="gd-horizontal">
            <span class="clr-generic ts-12 opacity-5">Details</span>
        </div>

        <div class="px-20 py-30 bg-white rounded-25 mt-20">
            <span class="ts-18 fc-black sans-regular">Verslag overleg {{ meeting?.meetingDate | date : "dd-MM-yyyy"}}</span>
            <h1 class="fc-black meeting-title" [matTooltip]="meeting.title">{{meeting.title}}</h1>

            <mat-form-field class="mt-10 full-width">
                <mat-label>{{ 'iq.meeting_time' | transloco }}</mat-label>
                <input data-cy="iq-audio-notes-summary__meeting-date-input" matInput [(ngModel)]="meeting.meetingDate" [matDatepicker]="datePickerStart" (focus)="datePickerStart.open()" (click)="datePickerStart.open()" name="newDecision_startDate">
                <mat-datepicker-toggle matSuffix [for]="datePickerStart" class="decision-fix-datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datePickerStart></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="mt-10 full-width">
                <mat-label>{{ 'iq.meeting_location' | transloco }}</mat-label>
                <input data-cy="iq-audio-notes-summary__location-input" matInput [(ngModel)]="meeting.location">
            </mat-form-field>

            <div class="pl-0">
                <app-multiselect-checkbox data-cy="iq-audio-notes-summary__multiselect-checkbox" [placeholder]="'reusable.selecteer_contactpersoon' | transloco" [(ngModel)]="meeting.contactpersons" [maxChipMessage]="'+ {count} '+('reusable.more' | transloco)+' '+('employees.labels' | transloco)+' ...'"
                (ngModelChange)="onUpdateContactpersons($event)">
                    <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' | transloco}}</app-generic-multiselect-checkbox-option-all>
                    <app-generic-multiselect-checkbox-option *ngFor="let employee of contactpersons" [value]="employee">
                        {{ employee.first_name }} {{ employee.last_name }}
                    </app-generic-multiselect-checkbox-option>
                </app-multiselect-checkbox>

                <app-generic-multiselect-checkbox data-cy="iq-audio-notes-summary__generic-multiselect-checkbox" #stakeholderMultiselect [placeholder]="'reusable.selecteer_stakeholder' | transloco" name="stakeholders" [(ngModel)]="meeting.stakeholders"
                        [maxChipMessage]="'+ {count} '+('reusable.more' | transloco)+' '+('stakeholders.labels' | transloco)+' ...'">
                    <app-generic-multiselect-checkbox-option-all>{{'filter_select_all' | transloco}}</app-generic-multiselect-checkbox-option-all>
                    <app-generic-multiselect-checkbox-option *ngFor="let stakeholder of stakeholders" [value]="stakeholder">
                        {{ stakeholder.name }}
                    </app-generic-multiselect-checkbox-option>
                </app-generic-multiselect-checkbox>
            </div>
            <div *ngIf="!showSummary" class="mt-15 px-12 py-8 bg-bugandy gd-horizontal align-center rounded-25">
                <div class="flex gap-15">
                    <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                    <span class="sans-regular fc-black ts-14 text-align-start">
                        {{ 'iq.meeting_notes_instruction_6' | transloco }}
                    </span>
                </div>
                <button data-cy="iq-audio-notes-summary__sans-regular-btn" mat-flat-button class="sans-regular my-0 mx-0 padding-25" (click)="showSummaries()">
                    {{ 'iq.meeting_notes_instruction_7' | transloco }}
                </button>
            </div>
        </div>

        <div *ngIf="showSummary">
            <div class="bg-bugandy mt-20">
                <div class="gd-horizontal">
                    <span class="clr-generic ts-12 opacity-5">{{ 'iq.speakers_and_contactpersons' | transloco }}</span>
                </div>
    
                <div class="px-20 py-30 bg-white rounded-25 mt-20">
                    <div class="gd-horizontal fc-black ts-10">
                        <span>{{ 'iq.speakers' | transloco }}</span>
                        <span class="col-xs-6 pr-0">{{ 'iq.connect_to_a_contactperson_in_dialog' | transloco }}</span>
                    </div>
                    <div class="gd-horizontal full-width" *ngFor="let speaker of meeting.speakers">
                        <span class="flex align-center">
                            <i class="uil uil-user-circle ts-24 mr-6" [style.color]="'#2800d2'"></i>
                            <span class="fc-black ts-13">{{ speaker.name }}</span>
                        </span>
                        <div class="col-xs-6 pr-0">
                            <app-generic-multiselect-checkbox data-cy="iq-audio-notes-summary__generic-multiselect-checkbox-2" name="contactperson" [(ngModel)]="speaker.contactperson" [multiple]="false">
                                <app-generic-multiselect-checkbox-option *ngFor="let contactperson of selectedContactPerson" [value]="contactperson">
                                    {{ contactperson.first_name }} {{ contactperson.last_name }}
                                </app-generic-multiselect-checkbox-option>
                            </app-generic-multiselect-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="bg-bugandy mt-20">
                <div class="gd-horizontal">
                    <span class="clr-generic ts-12 opacity-5">{{ 'iq.summary_report' | transloco }}</span>
                </div>
    
                <div class="px-20 py-20 bg-white rounded-25 mt-20">
                    <p class="ts-14 fc-black">
                        <textarea data-cy="iq-audio-notes-summary__summary-input"
                            class="noborder-text-area"
                            matInput
                            rows="4"
                            [(ngModel)]="meeting.summary">
                        </textarea>  
                    </p>
                </div>
            </div>

            <!-- Summary per spekaer -->
            
            <div class="bg-bugandy mt-20">
                <div class="gd-horizontal">
                    <span class="clr-generic ts-12 opacity-5">{{ 'iq.summary_per_speaker' | transloco }}</span>
                </div>
    
                <div class="px-25 py-25 bg-white rounded-25 mt-20 fc-black" *ngFor="let speaker of meeting.speakers">
                    <div>
                        <h3 class="mb-0">{{ (speaker.contactperson && speaker.contactperson.length > 0) ? (speaker.contactperson[0].first_name + ' ' + speaker.contactperson[0].last_name).trim() : speaker.name }}:</h3>
                        <p class="ts-14 fc-black">
                            <textarea data-cy="iq-audio-notes-summary__summary-input-2"
                            class="noborder-text-area"
                            matInput
                            rows="2"
                            [(ngModel)]="speaker.summary">
                        </textarea>  
                        </p>
                    </div>
                </div>
            </div>
            
            <div class="bg-bugandy mt-20">
                <div class="gd-horizontal">
                    <span class="clr-generic ts-12 opacity-5">{{ 'iq.subjects_summaries' | transloco }}</span>
                </div>
    
                <div *ngFor="let topic of meeting.topics">
                    <div class="px-25 py-25 bg-white rounded-25 mt-20 fc-black">
                        <div>
                            <h2 class="fc-black">{{ topic.title }}</h2>
                            <span>
                                <h3 class="mb-1">{{ 'iq.summary' | transloco }}:</h3>
                                <p class="ts-14 fc-black">
                                    <textarea data-cy="iq-audio-notes-summary__summary-input-3"
                                        class="noborder-text-area"
                                        matInput
                                        rows="2"
                                        [(ngModel)]="topic.summary">
                                    </textarea>  
                                </p>
                            </span>
                        </div>
    
                        
                    </div>
    
                    <div class="bg-bugandy">
                        <div class="px-25 py-25 bg-white rounded-25 fc-black border-generic">
                            <h3 class="mb-1">{{ 'iq.action' | transloco }}:</h3>
            
                            <!-- Show message when no tasks are found -->
                            <div *ngIf="!topic.tasks || topic.tasks.length === 0" class="text-center py-20">
                                <p class="ts-14 fc-black opacity-7">{{ 'iq.no_actions_found' | transloco }}</p>
                            </div>
            
                            <!-- Loop through topic.tasks -->
                            <div class="flex flex-end" *ngFor="let task of topic.tasks; let i = index">
                                <mat-form-field class="pl-0 col-xs-6">
                                    <mat-label>{{ 'iq.action' | transloco }}</mat-label>
                                    <input data-cy="iq-audio-notes-summary__description-input" matInput [(ngModel)]="task.description" [name]="'task_description_' + i">
                                </mat-form-field>
                                <mat-form-field class="pl-0 col-xs-3">
                                    <mat-label>{{ 'iq.select_a_deadline' | transloco }}</mat-label>
                                    <input data-cy="iq-audio-notes-summary__deadline-input" matInput [(ngModel)]="task.deadline" [matDatepicker]="datePickerStart" (focus)="datePickerStart.open()" (ngModelChange)="changeDeadline()" (click)="datePickerStart.open()" [name]="'task_deadline_' + i" required>
                                    <mat-datepicker-toggle matSuffix [for]="datePickerStart" class="decision-fix-datepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datePickerStart></mat-datepicker>
                                </mat-form-field>
                                <app-generic-multiselect-checkbox data-cy="iq-audio-notes-summary__generic-multiselect-checkbox-3" class="col-xs-3" placeholder="{{ 'iq.select_task_owner' | transloco }}" [name]="'task_owner_' + i" [(ngModel)]="task.users" [multiple]="false">
                                    <app-generic-multiselect-checkbox-option *ngFor="let user of users" [value]="user">
                                        {{ user.name }}
                                    </app-generic-multiselect-checkbox-option>
                                </app-generic-multiselect-checkbox>
                            </div>
            
                            <div *ngIf="topic.suggestedTasks && topic.suggestedTasks.length">
                                <div class="mt-5 px-12 py-8 bg-bugandy gd-horizontal align-center rounded-25" *ngFor="let task of topic.suggestedTasks; let tskIndex = index">
                                    <div class="flex gap-15">
                                        <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
                                        <span class="sans-regular fc-black ts-14 text-align-start">
                                            {{ 'iq.my_advice' | transloco }}: {{ task.advice }}
                                        </span>
                                    </div>
                                    <i data-cy="iq-audio-notes-summary__approve-suggested-task" class="uil uil-check-circle" style="cursor: pointer;" (click)="approveSuggestedTask(task, tskIndex)"></i>
                                </div>
                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showSummary" class="flex gap-20 pb-15 pt-20 px-8 mt-15 ml-10 pull-left">
        <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
        <span class="sans-regular fc-black ts-15 text-align-start">
            {{ 'iq.are_you_ready_with_editing_the_notes' | transloco }} <br> 
            {{ 'iq.by_saving_the_meeting_notes_a_contact_moment_will_be_created_for_you' | transloco }}
        </span>
    </div>
</div>